import { useState } from 'react';

import { Box, Button, Divider, Flex, Heading, SimpleGrid, Tag, Text } from '@chakra-ui/react';

import { ExternalLink } from '~/components/external-link';
import { format, useFormatDate } from '~/hooks/use-format-date';

import { NewsItem, NewsList } from '../models/news';

export function NewsPressSection({ press }: { press: NewsList }) {
  const [numberOfPressItemsToRender, setNumberOfPressItemsToRender] = useState(9);

  return (
    <Box as='section'>
      <Heading as='h2' marginBottom={{ base: '16px', md: '24px' }} size='marketing-4xl'>
        Press Releases
      </Heading>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: '24px', md: '32px' }}>
        {press.slice(0, numberOfPressItemsToRender).map((pressItem) => (
          <NewsPressCard key={pressItem._id} pressItem={pressItem} />
        ))}
      </SimpleGrid>
      {numberOfPressItemsToRender < press.length && (
        <Flex justifyContent='center'>
          <Button marginTop='56px' variant='outline' onClick={() => setNumberOfPressItemsToRender((prev) => prev + 9)}>
            Load More Press Releases
          </Button>
        </Flex>
      )}
    </Box>
  );
}

export function NewsPressCard({ pressItem }: { pressItem: NewsItem }) {
  const publishDate = useFormatDate({ date: new Date(pressItem.publishDate), format: format.monthDayYear });

  return (
    <Box as='article' bg='white' borderRadius='base' shadow='md'>
      <Flex bg='white' borderRadius='base' direction='column' gap='16px' padding='24px 24px 32px 24px'>
        <Heading as='h3' size='h4'>
          {pressItem.title}
        </Heading>
        <Divider />
        <Flex alignItems='flex-start' flexDirection='column' gap='8px'>
          <Tag>{publishDate}</Tag>
          <Text size='label'>{pressItem.publication}</Text>
        </Flex>
        <ExternalLink href={pressItem.newsLink} withArrow>
          Read more
        </ExternalLink>
      </Flex>
    </Box>
  );
}
